import React, { useEffect, useState } from 'react';
import { Button } from '@/components/Button';
import Input from '@/components/Input';
import { showErrorToast, showSuccessToast } from '../../../job_change_processes/lib/toast';
import useUpdateOrganizationCustomFields from '../../api/useUpdateOrganizationCustomFields';
import type { CustomField } from '../../types/Organization';

type Props = {
  candidateProfileCustomFields: CustomField[];
  onUpdate: () => void;
};

const ApiRequestParamsSection: React.FC<Props> = ({ candidateProfileCustomFields, onUpdate }) => {
  const [customFields, setCustomFields] = useState<CustomField[]>(candidateProfileCustomFields);
  const { mutateAsync: updateOrganizationCustomFields } = useUpdateOrganizationCustomFields();

  useEffect(() => {
    setCustomFields(candidateProfileCustomFields);
  }, [candidateProfileCustomFields]);

  const handleUpdateCustomFields = async () => {
    const changedFields = customFields
      .filter(
        (field) =>
          field.alias_id !== candidateProfileCustomFields.find((f) => f.id === field.id)?.alias_id
      )
      .map((field) => ({
        id: field.id,
        alias_id: field.alias_id,
      }));

    try {
      for (const field of changedFields) {
        await updateOrganizationCustomFields({ id: field.id.toString(), alias_id: field.alias_id });
      }
      showSuccessToast('識別子（パラメーターキー）を保存しました。');
      onUpdate();
    } catch (error) {
      showErrorToast('識別子（パラメーターキー）の更新に失敗しました');
    }
  };

  return (
    <div className="rounded-sm border-solid border-dark-gray bg-white px-12 py-8">
      <h2 className="text-xl font-bold">求職者の作成（POST）</h2>
      <div className="mt-6">
        <table className="w-full border-collapse border border-solid border-gray-200">
          <thead>
            <tr>
              <th className="border border-solid border-gray-200 bg-gray-100 p-4 text-left font-medium">
                コンテンツ
              </th>
              <th className="border border-solid border-gray-200 bg-gray-100 p-4 text-left font-medium">
                識別子（パラメーターキー）
              </th>
            </tr>
          </thead>
          <tbody>
            {customFields.length > 0 &&
              customFields.map((customField) => (
                <tr key={customField.id}>
                  <td className="border border-solid border-gray-200 p-4">{customField.name}</td>
                  <td className="border border-solid border-gray-200 p-4">
                    <Input
                      value={customField.alias_id}
                      className="bg-gray-50"
                      disabled={customField.name === '名前' && customField.alias_id === 'name'}
                      onChange={(e) => {
                        const newCustomFields = customFields.map((field) =>
                          field.id === customField.id
                            ? { ...field, alias_id: e.target.value }
                            : field
                        );
                        setCustomFields(newCustomFields);
                      }}
                    />
                  </td>
                </tr>
              ))}
            {customFields.length === 0 && (
              <tr>
                <td colSpan={2} className="border border-solid border-gray-200 p-4">
                  カスタムフィールドがありません
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <div className="mt-3 flex justify-end">
          <Button color="primary" size="md" onClick={handleUpdateCustomFields}>
            保存する
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ApiRequestParamsSection;
